import groq from 'groq';

import { RICH_TEXT } from '../common/richText';

export const FAQ = groq`
  _type,
  _key,
  title,
  subtitle[] {
    ${RICH_TEXT}
  },
  isFAQLinkEnabled,
  list[] {
    _key,
    question,
    answer[] {
      ${RICH_TEXT}
    }
  }
`;

export const FAQ_BLOCK = groq`
  _type == 'timeline_faq' => @-> {
    ${FAQ}
  }
`;
